import { Office } from "./Office";
import { ResizableImage } from "./ResizableImage";

enum WebsiteProfileDisplayType {
    Agent,
    PersonalAssistant,
    PropertyManager,
    CommercialAgent,
    Principal
}

interface Profile {
    Id: string;

    FirstName: string;
    LastName: string;
    FullName: string;

    Position: string;
    
    DisplayPriority: number;
    DisplayType: WebsiteProfileDisplayType;

    OfficePhone: string;
    MobilePhone: string;
    Email: string;
    Website: string;

    FacebookUrl: string;
    LinkedinUrl: string;
    TwitterUrl: string;
    RateMyAgentUrl: string;

    AboutAgent: string;

    Photo: ResizableImage;

    Office: Office;

    Slug: string;
}

export { Profile, WebsiteProfileDisplayType }